function isHttpLink(str) {
  return /^https:\/\/.+/g.test(str);
}

export default isHttpLink;
